import { Pipe, PipeTransform } from '@angular/core';
import { StatisticsExtractor } from 'app/trello/utility/statistics-extractor';

@Pipe({
  name: 'delta',
  pure: true,
})
export class DeltaPipe implements PipeTransform {

  constructor(
    private readonly statisticsExtractor: StatisticsExtractor,
  ) {
  }

  transform(
    values1: any[] | undefined,
    values2: any[] | undefined,
  ): number | undefined {
    return this.statisticsExtractor.delta(values1, values2);
  }

}
